import { render, staticRenderFns } from "./AddSaleTagetDialog.vue?vue&type=template&id=c713d1a0&scoped=true"
import script from "./AddSaleTagetDialog.vue?vue&type=script&lang=js"
export * from "./AddSaleTagetDialog.vue?vue&type=script&lang=js"
import style0 from "./AddSaleTagetDialog.vue?vue&type=style&index=0&id=c713d1a0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c713d1a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c713d1a0')) {
      api.createRecord('c713d1a0', component.options)
    } else {
      api.reload('c713d1a0', component.options)
    }
    module.hot.accept("./AddSaleTagetDialog.vue?vue&type=template&id=c713d1a0&scoped=true", function () {
      api.rerender('c713d1a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialog/AddSaleTagetDialog.vue"
export default component.exports